import React, { useState } from 'react'
import {
  Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper, Collapse, IconButton,
  Box,
} from '@mui/material'
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material'

interface Request {
  type: string
  count: number
}

interface UsageEntry {
  date: string
  count: number
  requests: Request[]
}

interface Props {
  data: UsageEntry[]
}

export const UsageStatsTable: React.FC<Props> = ({ data }) => {
  const [openRowIndex, setOpenRowIndex] = useState<number | null>(null)

  const toggleRow = (index: number) => {
    setOpenRowIndex(openRowIndex === index ? null : index)
  }

  const calculateTotal = (entries: UsageEntry[]) =>
    entries.reduce((sum, entry) => sum + entry.count, 0)

  const total = calculateTotal(data)

  return (
    <Paper elevation={3} style={{ padding: 16 }}>
      <TableContainer>
        <Table aria-label="usage stats table">
          <TableHead>
            <TableRow>
              <TableCell />
              <TableCell><strong>Date</strong></TableCell>
              <TableCell align="right"><strong>Total Per Day</strong></TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {data.map((entry, index) => (
              <React.Fragment key={entry.date}>
                <TableRow hover>
                  <TableCell>
                    <IconButton size="small" onClick={() => toggleRow(index)}>
                      {openRowIndex === index ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                    </IconButton>
                  </TableCell>
                  <TableCell>{entry.date}</TableCell>
                  <TableCell align="right">{entry.count}</TableCell>
                </TableRow>

                <TableRow>
                  <TableCell colSpan={3} style={{ paddingBottom: 0, paddingTop: 0 }}>
                    <Collapse in={openRowIndex === index} timeout="auto" unmountOnExit>
                      <Box margin={1}>
                        <Table size="small">
                          <TableHead>
                            <TableRow>
                              <TableCell>Types:</TableCell>
                              <TableCell align="right">Count</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {entry.requests.map((req, idx) => (
                              <TableRow key={idx}>
                                <TableCell>{req.type}</TableCell>
                                <TableCell align="right">{req.count}</TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </Box>
                    </Collapse>
                  </TableCell>
                </TableRow>
              </React.Fragment>
            ))}

          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  )
}
